// store.ts
import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { authApi } from '../store/auth/authApi';
import { userAPI } from '../store/user/userApi';
import { userDomAPI } from '../store/user/userDomApi';
import userAccessSlice from '../store/brokers/partners/user-access-control/userAccessSlice';
import partnersSlice from '../store/brokers/partners/partners/partnersSlice';
import historyChatsSlice from '../store/brokers/partners/history-chats/historyChatsSlice';
import featuresReducer from '../store/features/featuresSlices';
import chatsSlice from '../store/slices/chats.slice';
import { chatboxApi } from '../store/chatbox/chatboxApi';
import { tripsApi } from '../store/trips/tripsApi';
import chatsUISlice from '../store/brokers/partners/chats/ChatsUISlice';
import teamsSlice from '../store/brokers/partners/teams/teamsSlice';
import adminTripsSlice from '../store/admin/trips/adminTripsSlice';
import adminFeedbacksSlice from '../store/admin/feedbacks/feedbacksSlice';
import reportsSlice from '../store/admin/reports/reportsSlice';
import reviewsSlice from '../store/admin/reviews/reviews.slice';
import { ttsApi } from '../store/chatbox/ttsApi';
import tripFeedbacksReducer from '../store/admin/trips/feedbacksSlice'
import feedbackTopicsReducer  from '../store/admin/topics/feedbackTopicsSlice'
import journeyReportsReducer from '../store/admin/journey-reports/journeyReportsSlice'


// ⬇️ NEW: the modal endpoints slice
// ^ use the actual path/name you saved it under (the slice with tryToListFeedbacksByTrip / tryToUpdateFeedbackDescription / tryToDeleteFeedback)

export const store = configureStore({
  reducer: {
    [userAPI.reducerPath]: userAPI.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userDomAPI.reducerPath]: userDomAPI.reducer,
    [chatboxApi.reducerPath]: chatboxApi.reducer,
    [tripsApi.reducerPath]: tripsApi.reducer,
    [ttsApi.reducerPath]: ttsApi.reducer,

    userAccess: userAccessSlice,
    partners: partnersSlice,
    history: historyChatsSlice,
    features: featuresReducer,
    chatUi: chatsUISlice,
    teams: teamsSlice,
    chats: chatsSlice,

    adminTrips: adminTripsSlice,
    adminFeedbacks: adminFeedbacksSlice,

    // ⬇️ add this
    tripFeedbacks: tripFeedbacksReducer,
    
    feedbackTopics: feedbackTopicsReducer,

    reports: reportsSlice,
    reviews: reviewsSlice,
    journeyReports: journeyReportsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userAPI.middleware,
      authApi.middleware,
      userDomAPI.middleware,
      chatboxApi.middleware,
      tripsApi.middleware,
      ttsApi.middleware
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
